import React from "react";

export const Header = () => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  Empowering B2B
                  <span> Business</span>
                </h1>
                <p>
                  At GD Enterprise, we specialize in providing high-quality
                  packaging materials and expanding our reach into diverse goods
                  trading. Our goal is to help businesses streamline procurement
                  and maximize profitability with reliable, cost-effective
                  solutions.
                </p>
                <a
                  href="#features"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
